import { render, staticRenderFns } from "./TagReportParameters.vue?vue&type=template&id=082b0394"
import script from "./TagReportParameters.vue?vue&type=script&lang=js"
export * from "./TagReportParameters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports